import clsx from "clsx";

import "./ToolIcon.scss";

import { recordingToolIcon, recordingActiveIcon } from "./icons";

import type { ToolButtonSize } from "./ToolButton";

type RecordingButtonProps = {
  readonly title?: string;
  readonly name?: string;
  readonly checked: boolean;
  readonly isRecording: boolean;
  readonly elapsedSeconds: number;
  readonly onChange?: () => void;
  readonly isMobile?: boolean;
};

const DEFAULT_SIZE: ToolButtonSize = "small";

const formatTime = (seconds: number): string => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
};

export const RecordingButton = (props: RecordingButtonProps) => {
  return (
    <label
      className={clsx(
        "ToolIcon ToolIcon__Recording",
        `ToolIcon_size_${DEFAULT_SIZE}`,
        {
          "is-mobile": props.isMobile,
        },
      )}
      title={`${props.title}`}
      style={
        props.isRecording
          ? {
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
            }
          : undefined
      }
    >
      <input
        className="ToolIcon_type_checkbox"
        type="checkbox"
        name={props.name}
        onChange={props.onChange}
        checked={props.checked}
        aria-label={props.title}
        data-testid="toolbar-Recording"
      />
      <div className="ToolIcon__icon">
        {props.isRecording ? recordingActiveIcon : recordingToolIcon}
      </div>
      {props.isRecording && (
        <span
          style={{
            fontSize: 10,
            color: "#e03131",
            fontWeight: 600,
            whiteSpace: "nowrap",
            fontVariantNumeric: "tabular-nums",
            paddingRight: 4,
          }}
        >
          {formatTime(props.elapsedSeconds)}
        </span>
      )}
    </label>
  );
};
